import api from "./api";

// --- Types ---

export interface HospitalMdtBranding {
  id: string;
  hospitalId: string;
  logoUrl?: string | null;
  headerText?: string | null;
  footerText?: string | null;
  hospitalNameSnapshot?: string | null;
  addressSnapshot?: string | null;
  contactSnapshot?: string | null;
  signatureLeftLabel?: string;
  signatureRightLabel?: string;
  createdBy?: string | null;
  updatedBy?: string | null;
  createdAt?: string;
  updatedAt?: string;
}

export interface BrandingListResponse {
  branding: HospitalMdtBranding[];
  total: number;
  page: number;
  limit: number;
  totalPages: number;
}

export interface BrandingListParams {
  page?: number;
  limit?: number;
}

export interface BrandingPayload {
  logoUrl?: string | null;
  headerText?: string | null;
  footerText?: string | null;
  hospitalNameSnapshot?: string | null;
  addressSnapshot?: string | null;
  contactSnapshot?: string | null;
  signatureLeftLabel?: string;
  signatureRightLabel?: string;
}

export interface UploadLogoResponse {
  url: string;
  key: string;
}

const BASE = "/api/super-admin/hospital-mdt-branding";

export const getBrandingList = async (params?: BrandingListParams): Promise<BrandingListResponse> => {
  const { data } = await api.get(BASE, { params });
  return data.data;
};

export const getBranding = async (hospitalId: string): Promise<HospitalMdtBranding> => {
  const { data } = await api.get(`${BASE}/${hospitalId}`);
  return data.data;
};

export const upsertBranding = async (
  hospitalId: string,
  payload: BrandingPayload
): Promise<HospitalMdtBranding> => {
  const { data } = await api.put(`${BASE}/${hospitalId}`, payload);
  return data.data;
};

export const uploadLogo = async (hospitalId: string, file: File): Promise<UploadLogoResponse> => {
  const formData = new FormData();
  formData.append("file", file);
  const { data } = await api.post(`${BASE}/${hospitalId}/logo`, formData, {
    headers: { "Content-Type": "multipart/form-data" },
  });
  return data.data;
};